// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1UI9J","footer":"Form_footer__1MEme"};